export const exitSearchTitle = "IOFH$c";
export const suggestionsAnnouncement = "omJzg";
export const searchButtonTitle = "YITPCc";
export default {exitSearchTitle,suggestionsAnnouncement,searchButtonTitle};